module.exports = __webpack_public_path__ + "img/pictoEstablishementsCommon2.5d856721.svg";